import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import { BookingCalculatedDetails, calculateBookingDetails } from '../../api/bookingService';
import { AuthContext } from '../../providers/auth-context';
import { queryRetry } from '../query-retry';

export const useFetchCalculateBookingDetails = (
    roomCode: string,
    academicYear: string,
    paymentPlanId: string | null,
    enabled = true
) => {
    const userState = useContext(AuthContext);
    const userId = userState.session?.user.id ?? null;

    return useQuery<BookingCalculatedDetails, AxiosError>({
        enabled: enabled && Boolean(roomCode && academicYear),
        queryKey: ['calculateBookingDetails', roomCode, academicYear, paymentPlanId, userId],
        queryFn: () =>
            calculateBookingDetails({
                roomName: roomCode,
                academicYear,
                ...(paymentPlanId && { paymentPlanId }),
            }),
        retry: queryRetry,
        staleTime: Infinity,
    });
};
